import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import UnauthenticatedFallback from './UnauthenticatedFallback';

/**
 * Composant pour protéger les pages de commande/réservation
 * Affiche un fallback graphique au lieu d'une redirection silencieuse
 */
const OrderProtectedRoute = ({
  children,
  title,
  message,
}) => {
  const { user, isAuthenticated, loading: authLoading } = useAuth();

  // Afficher un loader pendant la vérification d'authentification
  if (authLoading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si l'utilisateur n'est pas authentifié, afficher le fallback
  if (!isAuthenticated) {
    return (
      <UnauthenticatedFallback
        title={title}
        message={message}
        showLoginButton={true}
        showSignupButton={true}
      />
    );
  }

  // Si authentifié, afficher le contenu
  return children;
};

export default OrderProtectedRoute;
